export let DiscountTypeDTO;

(function (DiscountTypeDTO) {
  DiscountTypeDTO["Percent"] = "percent";
  DiscountTypeDTO["Value"] = "value";
  DiscountTypeDTO["None"] = "none";
})(DiscountTypeDTO || (DiscountTypeDTO = {}));

export let ServiceStatusType;

(function (ServiceStatusType) {
  ServiceStatusType["AwaitingApproval"] = "awaitingApproval";
  ServiceStatusType["Approved"] = "approved";
  ServiceStatusType["Amended"] = "amended";
  ServiceStatusType["Completed"] = "completed";
  ServiceStatusType["Terminated"] = "terminated";
  ServiceStatusType["Canceled"] = "canceled";
})(ServiceStatusType || (ServiceStatusType = {}));

export let ServiceCostType;

(function (ServiceCostType) {
  ServiceCostType["Fixed"] = "fixed";
  ServiceCostType["Variable"] = "variable";
  ServiceCostType["Range"] = "range";
})(ServiceCostType || (ServiceCostType = {}));

export let DiscountType;

(function (DiscountType) {
  DiscountType["Value"] = "value";
  DiscountType["Percent"] = "percent";
})(DiscountType || (DiscountType = {}));

export let RecurrencePeriodTypes;

(function (RecurrencePeriodTypes) {
  RecurrencePeriodTypes["Weekly"] = "weekly";
  RecurrencePeriodTypes["BiWeekly"] = "biweekly";
  RecurrencePeriodTypes["Monthly"] = "monthly";
  RecurrencePeriodTypes["Quarterly"] = "quarterly";
  RecurrencePeriodTypes["Yearly"] = "yearly";
})(RecurrencePeriodTypes || (RecurrencePeriodTypes = {}));

export let ServiceChangeItemType;
/** Any change in price, pricingType, unitCap, unitName */

(function (ServiceChangeItemType) {
  ServiceChangeItemType["Pricing"] = "pricing";
  ServiceChangeItemType["Discount"] = "discount";
  ServiceChangeItemType["BillingTrigger"] = "billingTrigger";
  ServiceChangeItemType["Description"] = "description";
})(ServiceChangeItemType || (ServiceChangeItemType = {}));